import CustomInputNumberV2 from "../CustomInputNumberV2";

export default function LoyaltyProgramSpendBaseSlabs({ slab, updateLoyaltySlabs }) {
  const handleChange = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");
    updateLoyaltySlabs(index, field, nameValObj.value);
  };
  
  return (
    <section className="flex space-x-3">
      <div className="flex items-center gap-2">
        <div>
          <CustomInputNumberV2
            placeholder={'200'}
            min={0}
            max={99999}
            addonAfter="TK"
            name={`${slab.uuid}_minAmount`}
            value={slab.minAmount}
            setValue={handleChange}
            shouldSetValueSetObj={true}
            isDecimalAllowed={true}
            inputClasses="flex-1"
          />
        </div>
        <div>spend</div>
      </div>
      <div className="flex items-center gap-2">
        <div>
          <CustomInputNumberV2
            placeholder={'10'}
            min={0}
            max={100}
            addonAfter="%"
            name={`${slab.uuid}_discountPercent`}
            value={slab.discountPercent}
            setValue={handleChange}
            shouldSetValueSetObj={true}
            isDecimalAllowed={true}
            inputClasses="flex-1"
          />
        </div>
        <div>off</div>
      </div>
    </section>
  );
}
